var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 360,
    viewBox: "0 0 360 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1928_12651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6595 263.061H132.417V302.279H46.6595V263.061Z",
    fill: "white",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.098 262.016L68.1161 286.854L74.3762 276.658L80.6362 286.854L86.2362 277.737L91.351 286.07V262.082L68.098 262.016Z",
    fill: "#FEBA91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3365 135.682L76.1996 127.746",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.924 200.748C120.451 195.082 122.094 184.575 108.492 178.053C94.8894 171.531 86.5919 165.048 82.9661 150.535",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.479 148.43L82.0888 135.831C81.7372 134.524 80.3928 133.75 79.0859 134.102L77.3426 134.571C76.0357 134.922 75.2614 136.267 75.613 137.574L79.0032 150.173C79.3548 151.48 80.6993 152.254 82.0061 151.902L83.7495 151.433C85.0563 151.082 85.8306 149.737 85.479 148.43Z",
    fill: "#49BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4356 174.313L46.2195 174.307",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6013 170.738H55.5538C54.2005 170.738 53.1034 171.835 53.1034 173.189V174.994C53.1034 176.347 54.2005 177.444 55.5538 177.444H68.6013C69.9546 177.444 71.0517 176.347 71.0517 174.994V173.189C71.0517 171.835 69.9546 170.738 68.6013 170.738Z",
    fill: "#49BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1439 173.776C69.1439 173.776 99.3411 172.076 113.45 197.439",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.717 230.643C255.821 230.643 261.581 232.535 261.967 250.773C262.353 269.011 261.545 285.497 277.459 285.286C292.164 285.09 288.897 279.141 295.693 279.403",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.252 272.082H294.259C293.175 272.082 292.297 272.96 292.297 274.044V284.629C292.297 285.713 293.175 286.591 294.259 286.591H311.252C312.335 286.591 313.214 285.713 313.214 284.629V274.044C313.214 272.96 312.335 272.082 311.252 272.082Z",
    fill: "#49BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.022 272.061L306.001 286.615",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.769 275.961H320.969M309.769 281.386H320.969",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.122 66.3633V73.7898M257.835 70.0765H250.411",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.31 93.5551V100.979M205.021 97.2683H197.597M158.693 57.4746V64.8981M162.403 61.1878H154.979M113.983 117.872V125.295M117.696 121.582H110.27M62.7392 89.1094V96.5359M66.4495 92.8227H59.026M54.6346 199.183V206.607M58.3448 202.897H50.9214M39.7304 137.74V145.167M43.4437 141.453H36.0172M287.719 159.049V166.476M291.432 162.762H284.008M301.447 97.4763V104.903M305.157 101.19H297.734M328.899 206.504V213.928M332.612 210.215H325.185",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.784 206.212L257.244 175.49H205.03L205.542 176.129H114.245L80.7749 206.851V214.781H114.23V303.283H257.784V214.127H290.784V206.212Z",
    fill: "#5D87FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.128 256.461H237.807V287.05H229.44V255.937H222.643L234.148 223.777L245.128 256.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.623 183.318V300.451M205.361 183.282L174.727 214.353M201.964 179.529L174.468 207.418M114.55 214.694H174.513V207.556H81.6188M257.569 214.067H225.401V206.929H288.071M205.711 183.107L225.003 213.973M213.176 187.754L225.449 207.068",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.069 233.648H130.578C128.081 233.648 126.057 235.673 126.057 238.169V264.424C126.057 266.921 128.081 268.945 130.578 268.945H187.069C189.566 268.945 191.59 266.921 191.59 264.424V238.169C191.59 235.673 189.566 233.648 187.069 233.648Z",
    fill: "#2E186A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.637 257.178C132.511 257.18 132.387 257.157 132.271 257.109C132.155 257.062 132.05 256.992 131.962 256.903C131.871 256.816 131.801 256.711 131.753 256.595C131.706 256.479 131.684 256.354 131.687 256.228C131.684 256.031 131.743 255.838 131.856 255.677L143.288 239.148C143.374 239.022 143.491 238.921 143.628 238.854C143.765 238.786 143.917 238.756 144.069 238.765C144.194 238.764 144.318 238.787 144.434 238.834C144.55 238.881 144.655 238.951 144.744 239.04C144.832 239.128 144.902 239.234 144.949 239.349C144.996 239.465 145.02 239.59 145.018 239.715V255.279H147.881C148.006 255.279 148.13 255.304 148.245 255.351C148.36 255.399 148.465 255.469 148.553 255.557C148.641 255.645 148.711 255.75 148.759 255.865C148.806 255.98 148.831 256.104 148.831 256.228C148.831 256.353 148.806 256.476 148.759 256.592C148.711 256.707 148.641 256.812 148.553 256.9C148.465 256.988 148.36 257.058 148.245 257.105C148.13 257.153 148.006 257.178 147.881 257.178H145.018V262.32C145.018 262.571 144.918 262.813 144.74 262.991C144.562 263.169 144.321 263.269 144.069 263.269C143.817 263.269 143.575 263.169 143.397 262.991C143.219 262.813 143.119 262.571 143.119 262.32V257.178H132.637ZM143.119 255.279V242.789L134.472 255.279H143.119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.278 250.972C151.239 248.843 151.507 246.719 152.074 244.667C152.604 242.893 153.35 241.486 154.31 240.447C154.885 239.911 155.547 239.479 156.269 239.169C157.003 238.863 157.789 238.705 158.584 238.705C159.379 238.705 160.166 238.863 160.899 239.169C161.616 239.482 162.276 239.914 162.849 240.447C163.819 241.49 164.567 242.897 165.091 244.667C166.144 248.81 166.144 253.152 165.091 257.295C164.567 259.072 163.819 260.478 162.849 261.515C162.277 262.05 161.618 262.482 160.899 262.793C160.166 263.101 159.379 263.26 158.584 263.26C157.789 263.26 157.002 263.101 156.269 262.793C155.549 262.487 154.888 262.056 154.316 261.521C153.356 260.48 152.61 259.074 152.08 257.301C151.51 255.241 151.24 253.109 151.278 250.972ZM158.578 240.595C158.033 240.587 157.492 240.692 156.989 240.902C156.486 241.113 156.032 241.425 155.654 241.819C154.011 243.657 153.19 246.708 153.192 250.972C153.194 255.236 154.015 258.302 155.654 260.171C156.033 260.562 156.487 260.871 156.99 261.078C157.494 261.286 158.034 261.387 158.578 261.376C159.122 261.384 159.661 261.281 160.164 261.074C160.666 260.867 161.121 260.559 161.502 260.171C163.157 258.314 163.984 255.248 163.982 250.972C163.98 246.696 163.153 243.645 161.502 241.819C161.122 241.429 160.667 241.12 160.164 240.91C159.662 240.701 159.122 240.596 158.578 240.601V240.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.368 257.178C169.243 257.179 169.119 257.155 169.004 257.108C168.888 257.061 168.783 256.991 168.695 256.902C168.607 256.814 168.537 256.709 168.49 256.593C168.443 256.477 168.42 256.353 168.422 256.228C168.419 256.032 168.477 255.839 168.588 255.677L180.023 239.148C180.108 239.022 180.225 238.92 180.362 238.853C180.499 238.786 180.651 238.756 180.803 238.765C180.928 238.762 181.052 238.785 181.168 238.832C181.284 238.879 181.388 238.95 181.475 239.04C181.565 239.127 181.636 239.233 181.684 239.349C181.731 239.465 181.755 239.589 181.753 239.715V255.279H184.613C184.738 255.277 184.863 255.3 184.979 255.348C185.095 255.396 185.2 255.467 185.288 255.556C185.464 255.736 185.562 255.978 185.562 256.23C185.562 256.482 185.464 256.723 185.288 256.904C185.2 256.992 185.094 257.062 184.978 257.109C184.862 257.157 184.738 257.18 184.613 257.178H181.744V262.32C181.746 262.445 181.722 262.57 181.675 262.686C181.627 262.802 181.556 262.907 181.466 262.995C181.287 263.17 181.045 263.269 180.794 263.269C180.543 263.269 180.302 263.17 180.122 262.995C180.032 262.907 179.961 262.802 179.914 262.686C179.866 262.57 179.843 262.445 179.845 262.32V257.178H169.368ZM179.854 255.279V242.789L171.195 255.279H179.854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.396 123.902C234.368 122.248 230.025 123.269 230.025 123.269C226.191 114.731 214.051 106.798 214.051 106.798C205.512 111.244 209.433 129.373 209.433 129.373L204.553 131.202C198.453 123.794 189.911 115.689 187.449 115.514C181.762 115.111 181.566 140.615 181.566 140.615C167.728 148.846 153.575 157.448 142.562 164.859C142.969 159.564 145.491 152.722 151.64 144.364C162.882 129.068 165.366 108.838 154.994 96.6047C140.44 79.4249 127.106 85.2721 119.176 92.8583C111.156 100.526 109.935 114.035 122.492 105.059C135.123 96.0169 141.317 100.701 147.242 111.858C153.168 123.016 134.867 140.19 126.328 154.127C121.539 161.945 119.179 169.67 119.282 176.129H177.211C177.093 176.261 176.978 176.391 176.876 176.521L179.748 176.129H198.191C205.554 183.215 222.815 196.419 226.67 188.809C228.614 184.978 229.464 180.776 228.656 176.789C230.365 180.053 235.712 189.276 240.36 186.693C244.386 184.456 247.593 178.193 246.813 171.623C249.808 168.859 252.114 165.917 253.558 162.831C265.322 141.661 245.746 125.376 240.396 123.902Z",
    fill: "#49BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.409 136.519C253.6 125.536 270.596 123.969 270.596 123.969M249.417 145.407C251.117 142.007 263.667 134.949 273.079 137.694",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.243 154.688C203.098 153.006 192.811 151.852 184.938 159.411M207.803 150.158C202.835 145.845 189.631 144.666 180.481 151.595",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.198 117.693C190.198 117.693 183.66 133.249 190.852 138.49",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.428 108.936C215.428 108.936 212.028 120.69 215.166 128.674",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.733 147.931C217.961 147.509 218.416 145.596 217.75 143.658C217.084 141.72 215.549 140.491 214.321 140.914C213.093 141.336 212.638 143.249 213.304 145.186C213.97 147.124 215.505 148.353 216.733 147.931Z",
    fill: "#2E186A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.379 142.31C235.607 141.888 236.062 139.975 235.396 138.037C234.73 136.099 233.195 134.87 231.967 135.292C230.739 135.714 230.284 137.628 230.95 139.565C231.616 141.503 233.151 142.732 234.379 142.31Z",
    fill: "#2E186A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.795 145.946L230.624 149.521C230.465 149.769 230.215 149.946 229.927 150.013C229.64 150.08 229.337 150.032 229.084 149.879L225.724 147.875C225.544 147.774 225.4 147.621 225.308 147.437C225.217 147.252 225.183 147.045 225.211 146.841C225.239 146.637 225.327 146.446 225.465 146.293C225.603 146.14 225.783 146.032 225.983 145.982L231.514 144.412C232.469 144.138 233.283 145.123 232.795 145.946Z",
    fill: "#2E186A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.002 153.281C230.465 157.672 230.353 152.202 229.805 149.32C230.92 151.825 233.87 155.457 234.326 151.43",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.683 190.966C222.333 190.008 216.866 179.133 211.461 175.037M219.219 171.812C219.479 171.9 225.85 182.361 226.103 189.505",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.864 176.526C181.831 170.381 204.593 158.485 217.251 164.238C229.91 169.992 230.977 180.318 226.664 188.814",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.487 170.498C232.487 170.498 238.37 181.674 238.5 187.099M239.808 168.023C239.808 168.023 244.121 181.029 241.574 186.062",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.086 166.15C223.674 163.597 237.635 155.254 243.82 163.934C244.944 165.511 246.171 168.582 246.671 170.246",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.904175 302.523H359.096",
    stroke: "#2E186A",
    strokeWidth: 1.80839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1928_12651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 360,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorimg);
export default __webpack_public_path__ + "static/media/errorimg.3eeeff6ee11a4f90d7b06db4e7a46da4.svg";
export { ForwardRef as ReactComponent };